<style scoped>
@import url("../assets/css/index.css");
</style>

<template>
    <div>
        <div class="page-loading" v-show="!show">
            <div class="loading-content">
                <img src="../assets/images/page_loading.gif">
                <p class="title">正在加载...</p>
            </div>
        </div>
        <div class="home-content common-home-content max-640" v-show="show">
            <div class="sex-btns-content space_pl space_pr">
                <div class="sex-btns clearfix pr">
                    <button 
                        class="sex-btn sex0 fl"
                        :class="sex_id == 0?'active':''"
                        @click="menuClick(0, 0)"
                    >男</button>
                    <button 
                        class="sex-btn sex1 fl"
                        :class="sex_id == 1?'active':''"
                        @click="menuClick(1, 0)"
                    >女</button>
                    <button 
                        class="sex-btn sex2 fl"
                        :class="sex_id == 2?'active':''"
                        @click="menuClick(2, 0)"
                    >儿童</button>
                    <div class="switch-normal switch_to_normal" v-show="img_show"
                        @click="changeShow()"
                    >
                        <div class="switch_normal"></div>
                        列表
                    </div>
                    <div class="switch-normal switch_to_normal" v-show="!img_show"
                        @click="changeShow()"
                    >
                        <div class="switch_human"></div>
                        人体
                    </div>
                </div>
            </div>
            <div class="human-main" v-show="img_show">
                <div class="human-male pr none"
                    :class="sex_id == 0?'show':''"
                >
                    <img class="human-bg-img" src="../assets/images/dstree/human_male_20180517.png" alt="">
                    <div class="tc body_area male-area1" data-area="1"
                        @click="menuClick(1, 3)"
                    >
                        <span class="area-icon area-tjmk"></span>
                        <span class="area">头颈面口</span>
                        <span class="area-disease">头痛、眩晕等</span>
                    </div>
                    <div class="tc body_area male-area2" data-area="3"
                        @click="menuClick(3, 3)"
                    >
                        <span class="area-icon area-xx"></span>
                        <span class="area">心胸</span>
                        <span class="area-disease">心悸、咳嗽等</span>
                    </div>
                    <div class="tc body_area male-area3" data-area="5"
                        @click="menuClick(5, 3)"
                    >
                        <span class="area-icon area-yb"></span>
                        <span class="area">腰背</span>
                        <span class="area-disease">腰痛下肢疼痛</span>
                    </div>
                    <div class="tc body_area male-area4" data-area="6"
                        @click="menuClick(6, 3)"
                    >
                        <span class="area-icon area-szgj"></span>
                        <span class="area">四肢关节</span>
                        <span class="area-disease">关节痛等</span>
                    </div>
                    <div class="tc body_area male-area5" data-area="7"
                        @click="menuClick(7, 3)"
                    >
                        <span class="area-icon area-pf"></span>
                        <span class="area">皮肤</span>
                        <span class="area-disease">湿疹、皮癣等</span>
                    </div>
                    <div class="tc body_area male-area6" data-area="2"
                        @click="menuClick(2, 3)"
                    >
                        <span class="area-icon area-ebh"></span>
                        <span class="area">耳鼻喉</span>
                        <span class="area-disease">鼻塞、鼻痒等</span>
                    </div>
                    <div class="tc body_area male-area7" data-area="4"
                        @click="menuClick(4, 3)"
                    >
                        <span class="area-icon area-fb"></span>
                        <span class="area">腹部</span>
                        <span class="area-disease">便秘、腹泻等</span>
                    </div>
                    <div class="tc body_area male-area8" data-area="8"
                        @click="menuClick(8, 3)"
                    >
                        <span class="area-icon area-mnsz"></span>
                        <span class="area">泌尿生殖</span>
                        <span class="area-disease">阳痿、早泄等</span>
                    </div>
                    <div class="tc body_area male-area9" data-area="0"
                        @click="menuClick(0, 3)"
                    >
                        <span class="area-icon area-qs"></span>
                        <span class="area">全身</span>
                        <span class="area-disease">感冒、失眠等</span>
                    </div>
                </div>
                <div class="human-female pr none"
                    :class="sex_id == 1?'show':''"
                >
                    <img class="human-bg-img" src="../assets/images/dstree/human_female_20180531.png" alt="">
                    <div class="tc body_area female-area1" data-area="2"
                        @click="menuClick(2, 3)"
                    >
                        <span class="area-icon area-tjmk2"></span>
                        <span class="area">头颈面口</span>
                        <span class="area-disease">头痛、眩晕等</span>
                    </div>
                    <div class="tc body_area female-area2" data-area="4"
                        @click="menuClick(4, 3)"
                    >
                        <span class="area-icon area-xxv"></span>
                        <span class="area">心胸</span>
                        <span class="area-disease">心悸、咳嗽等</span>
                    </div>
                    <div class="tc body_area female-area3" data-area="6"
                        @click="menuClick(6, 3)"
                    >
                        <span class="area-icon area-yb"></span>
                        <span class="area">腰背</span>
                        <span class="area-disease">腰痛下肢疼痛</span>
                    </div>
                    <div class="tc body_area female-area4" data-area="7"
                        @click="menuClick(7, 3)"
                    >
                        <span class="area-icon area-szgj"></span>
                        <span class="area">四肢关节</span>
                        <span class="area-disease">关节痛等</span>
                    </div>
                    <div class="tc body_area female-area5" data-area="8"
                        @click="menuClick(8, 3)"
                    >
                        <span class="area-icon area-pf"></span>
                        <span class="area">皮肤</span>
                        <span class="area-disease">湿疹、皮癣等</span>
                    </div>
                    <div class="tc body_area female-area6" data-area="3"
                        @click="menuClick(3, 3)"
                    >
                        <span class="area-icon area-ebh"></span>
                        <span class="area">耳鼻喉</span>
                        <span class="area-disease">鼻塞、鼻痒等</span>
                    </div>
                    <div class="tc body_area female-area7" data-area="5"
                        @click="menuClick(5, 3)"
                    >
                        <span class="area-icon area-fb"></span>
                        <span class="area">腹部</span>
                        <span class="area-disease">便秘、腹泻等</span>
                    </div>
                    <div class="tc body_area female-area8" data-area="9"
                        @click="menuClick(9, 3)"
                    >
                        <span class="area-icon area-mnsz"></span>
                        <span class="area">泌尿生殖</span>
                        <span class="area-disease">小便浑浊等</span>
                    </div>
                    <div class="tc body_area female-area9" data-area="0"
                        @click="menuClick(0, 3)"
                    >
                        <span class="area-icon area-fk"></span>
                        <span class="area">妇科</span>
                        <span class="area-disease">痛经、不孕等</span>
                    </div>
                    <div class="tc body_area female-area10" data-area="1"
                        @click="menuClick(1, 3)"
                    >
                        <span class="area-icon area-qs"></span>
                        <span class="area">全身</span>
                        <span class="area-disease">感冒、失眠等</span>
                    </div>
                </div>
                <div class="human-child pr none"
                    :class="sex_id == 2?'show':''"
                >
                    <img class="human-bg-img" src="../assets/images/dstree/human_child_20180531.png" alt="">
                    <div class="tc body_area child-area1" data-area="1"
                        @click="menuClick(1, 3)"
                    >
                        <span class="area-icon area-xx"></span>
                        <span class="area">心胸</span>
                        <span class="area-disease">小儿咳嗽等</span>
                    </div>
                    <div class="tc body_area child-area2" data-area="0"
                        @click="menuClick(0, 3)"
                    >
                        <span class="area-icon area-qs"></span>
                        <span class="area">全身</span>
                        <span class="area-disease">感冒、水痘等</span>
                    </div>
                    <div class="tc body_area child-area3" data-area="2"
                        @click="menuClick(2, 3)"
                    >
                        <span class="area-icon area-fb"></span>
                        <span class="area">腹部</span>
                        <span class="area-disease">食欲不振等</span>
                    </div>
                </div>
            </div>
            <div v-show="!img_show">
                <div class="mt15 pb15 space_pl space_pr">
                    <h2 class="recommend-title">{{rTitle}}</h2>
                    <ul class="recommend-list clearfix">
                        <li 
                            class="fl" data-trace=""
                            v-for="(category,index) in categories"
                            :key="index"
                            @click="question(category.trace)"
                        >
                            <div class="box">{{category.text}}</div>
                        </li>
                    </ul>
                </div>
                <div class="disease-content clearfix">
                    <div class="disease-sort fl">
                        <ul class="disease-sort-ul">
                            <li 
                                :class="sort_index == index?'active':''"
                                v-for="(sort,index) in sorts"
                                :key="index"
                                @click="menuClick(index, 1)"
                                >
                                <span class="sort-icon" :class="['icon-'+sort.icon, 'icon-'+sort.icon+sex_id]"></span>{{sort.text}}
                            </li>
                        </ul>
                    </div>
                    <div class="disease-list fr">
                        <ul class="disease-select">
                            <li 
                                v-for="(disease,index) in diseases"
                                :key="index"
                                @click="question(disease.trace)"
                            >
                                <span class="text">{{disease.text}}</span>
                                <span class="arrow_box"></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../assets/api/friggApiConfig'
export default {
  data() {
    return {
      locData: {},
      img_show: true,
      categories: null,
      sorts: null,
      diseases: null,
      rTitle: "常见疾病",
      sex_id: 0,
      sort_index: 0,
      show: false
    };
  },
  created() {
    var sex = this.$route.query.sex;
    if(sex){
        this.sex_id = parseInt(sex);
    }
    this.loadinti();
    window.appBack = ()=> this.pageback();
  },
  methods: {
    loadinti(){
        var that = this;
        http.get("/zhen/goods/panel").then(function(res) {
            that.locData = res.data;
            that.$set(that.locData);
            var current_first_sort = that.locData.classifier.root.children[0].children[that.sex_id].children;
            for (var i = current_first_sort.length - 1; i >= 0; i--) {
                if(that.sex_id == 1 && current_first_sort[i].text == '心胸'){
                    current_first_sort[i].icon = 'xxv'
                }else{
                    current_first_sort[i].icon = that.locData.icons[current_first_sort[i].text];
                }
            }
            
            that.rTitle = current_first_sort[0].text;
            that.categories = current_first_sort[0].children;
            that.sorts = current_first_sort.slice(1,current_first_sort.length);
            that.diseases = current_first_sort[1].children;
            that.show = true;
            that.$appUtils.appCloseLoadingView();
        });
    },
    changeShow(){
        this.img_show = !this.img_show;
    },
    menuClick(index, type){
        if(type == 0){
            let current_first_sort = this.locData.classifier.root.children[0].children[index].children;
            for (let i = current_first_sort.length - 1; i >= 0; i--) {
                if(this.sex_id == 1 && current_first_sort[i].text == '心胸'){
                    current_first_sort[i].icon = 'xxv'
                }else{
                    current_first_sort[i].icon = this.locData.icons[current_first_sort[i].text];
                }
            }
            this.sex_id = index;
            this.sort_index = 0;
            this.categories = current_first_sort[0].children;
            this.sorts = current_first_sort.slice(1,current_first_sort.length);
            this.diseases = current_first_sort[1].children;
            
        }else if(type == 1 || type == 3){
            if(type == 3){
                this.img_show = false;
            }
            let current_first_sort = this.locData.classifier.root.children[0].children[this.sex_id].children;
            for (let i = current_first_sort.length - 1; i >= 0; i--) {
                if(this.sex_id == 1 && current_first_sort[i].text == '心胸'){
                    current_first_sort[i].icon = 'xxv'
                }else{
                    current_first_sort[i].icon = this.locData.icons[current_first_sort[i].text];
                }
            }
            this.sort_index = index;
            this.diseases = current_first_sort[index+1].children;
        }else{
            this.categories = this.locData.classifier.root.children[0].children[index].children[0].children;
            this.sex_id = index;
        }
        
    },
    question(traceId) {
        if(this.$route.query.dark){
            this.$router.push({ path: "/question/" + traceId + '?sex=' +  this.sex_id+'&dark='+this.$route.query.dark});
        }else{
            this.$router.push({ path: "/question/" + traceId + '?sex=' +  this.sex_id});
        }
        
    },
    pageback(){
        var t = this.$route.query.t;
        if(t){
            window.history.back();
            return true;
        }else{
            return null;
        }
    }
  }
}
</script>

